// Copyright (c) 2022 by Move Closer

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const THANK_YOU_DEFAULT_CONFIG = {
  createAccountStrategy: 'drawer'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const THANK_YOU_COMPONENT_KEY = 'ThankYouComponent'
